<template>
  <div class="NominaPreliminar">
    <md-table-card class="m-t-16">
      <md-toolbar>
        <h1 class="md-title">Nomina preliminar</h1>
      </md-toolbar>
      <md-table class="tablita">
        <md-table-header>
          <md-table-row>
            <md-table-head># emp</md-table-head>
            <md-table-head>Nombre</md-table-head>
            <md-table-head>Percepciones</md-table-head>
            <md-table-head>Deducciones</md-table-head>
            <md-table-head>Total</md-table-head>
            <md-table-head> </md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="(n,index) in empleados" :key="index">
            <md-table-cell>{{n.empleado}}</md-table-cell>
            <md-table-cell>{{n.nombre_empleado}}</md-table-cell>
            <md-table-cell>{{nF(n.percepciones)}}</md-table-cell>
            <md-table-cell>{{nF(n.deducciones)}}</md-table-cell>
            <md-table-cell>{{nF(n.percepciones - n.deducciones)}}</md-table-cell>
            <md-table-cell>
              <md-button style="width:auto" class="md-icon-button" @click.native="obtenerDetalleNominaEmpleado(n.empleado,n.nombre_empleado, n.desde_npe, n.hasta_npe)">
                <md-icon>more_vert</md-icon>
                <md-tooltip md-direction="left">Detalle</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
    </md-table-card>
    <md-dialog md-open-from="#fab" md-close-to="#fab" ref="modalDetalleNominaEmpleado">
      <md-dialog-content id="recibo-nomina">
        <div class="md-title">{{empleado}}</div>
        <div class="md-subheading">Periodo del {{desde}} al {{hasta}}</div>
        <md-table>
          <md-table-header>
            <md-table-row>
              <md-table-head>Concepto</md-table-head>
              <md-table-head>Tipo</md-table-head>
              <md-table-head>Desde</md-table-head>
              <md-table-head>Total</md-table-head>
              <md-table-head>Resto</md-table-head>
              <md-table-head>Quincenas</md-table-head>
              <md-table-head>Importe qnal</md-table-head>
            </md-table-row>
          </md-table-header>
          <md-table-body>
            <md-table-row v-for="(c, index) in conceptos" :key="index">
              <md-table-cell>{{c.desc_con}}</md-table-cell>
              <md-table-cell>{{c.tipo_con.toUpperCase()}}</md-table-cell>
              <md-table-cell>{{c.desde_pdn}}</md-table-cell>
              <md-table-cell>{{ (!c.desde_pdn) ? nF(c.importe_npr) : nF(c.importe_pdn) }}</md-table-cell>
              <md-table-cell>{{ (!c.desde_pdn) ? null : nF(c.resto_pdn) }}</md-table-cell>
              <md-table-cell>{{ (!c.desde_pdn) ? null : c.qnas_pdn }}</md-table-cell>
              <md-table-cell>{{ (!c.desde_pdn) ? nF(c.importe_npr) : nF(c.importe_qnal_pdn) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell>TOTAL</md-table-cell>
              <md-table-cell>${{total}}</md-table-cell>
            </md-table-row>
          </md-table-body>
        </md-table>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="printJS('recibo-nomina', 'html')">
          <md-icon>print</md-icon>
          Imprimir
        </md-button>
        <md-button class="md-accent md-raised" @click.native="cerrarModal('modalDetalleNominaEmpleado')">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
import printJS from "print-js";

export default {
  name: "NominaPreliminar",
  methods: {
    nF(numerito) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(numerito);
    },
    printJS(a, b) {
      return printJS(a, b);
    },
    calcularTotal(conceptos) {},
    obtenerEmpleados() {
      this.$http
        .post("nomina/resumen", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "empleados" in response.body) {
              this.empleados = response.body.empleados;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    obtenerDetalleNominaEmpleado(e, nombre, a, b) {
      this.empleado = nombre;
      this.desde = a;
      this.hasta = b;
      this.id_emp = e;
      this.$http
        .post("nomina/detalle", {
          token: this.$session.get("token"),
          empleado: sha1(md5(e))
        })
        .then(
          response => {
            if (response.status === 200 && "conceptos" in response.body) {
              this.conceptos = response.body.conceptos;
              this.total = response.body.total;
              this.$refs["modalDetalleNominaEmpleado"].open();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerEmpleados();
  },
  updated() {
    $(".md-table.tablita > table").DataTable();
  },
  data() {
    return {
      empleados: [],
      id_emp: null,
      desde: null,
      hasta: null,
      total: 0,
      empleado: null,
      conceptos: [],
      observaciones_ene: null,
      estatus_old: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// NominaResumen.vue?22a4c2c8